import { b64ToBlob } from '../../elements/helper/b64ToBlob';

export function resizeImage(img64: string, callback: (rszImg64: string) => void, MAX_WIDTH: number = 800, MAX_HEIGHT: number = 800, file?: any) {
    const img = document.createElement('img');
    img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        // resize
        let width = img.width;
        let height = img.height;
        if (width > height) {
            if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
            }
        } else {
            if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
            }
        }
        console.log('resizeImage:', img.width, img.height, '->', width, height, file);
        // set
        canvas.width = width;
        canvas.height = height;
        const ctx2 = canvas.getContext('2d');
        ctx2.drawImage(img, 0, 0, width, height);

        const rszImg64 = canvas.toDataURL('image/png');
        const rszImg64j = canvas.toDataURL('image/jpeg');
        // console.log('resize png', rszImg64.length);
        // console.log('resize jpeg', rszImg64j.length);

        // callback
        if (file && file.type === 'image/png') {
            callback(rszImg64);
        } else {
            callback(rszImg64.length < rszImg64j.length ? rszImg64 : rszImg64j);
        }
    };
    img.onerror = (err) => {
        console.error(err);
    };
    img.src = img64;
}

export function resizeImageB64ToUrl(b64: string, mimeType: string, callback: (url: string) => void, MAX_WIDTH: number = 800, MAX_HEIGHT: number = 800, file?: any) {
    const b64Header = `data:${mimeType};base64,`;
    if (!b64.startsWith(b64Header)) {
        b64 = b64Header + b64;
    }
    resizeImage(b64, (rszImg64: string) => {
        if (rszImg64.startsWith(b64Header)) {
            rszImg64 = rszImg64.replace(b64Header, '');
        }
        b64ToBlob(rszImg64, mimeType, (rszBlob: any) => {
            const rszUrl = window.URL.createObjectURL(rszBlob);
            callback(rszUrl);
        });
    }, MAX_WIDTH, MAX_HEIGHT, file);
}
